import { WA_MESSAGES } from "@/config/business";
import { CallButton, WhatsAppButton } from "./CtaButtons";

const FinalCta = () => (
  <section className="relative overflow-hidden bg-[#1C1917] py-20 sm:py-24">
    <div
      className="pointer-events-none absolute -top-32 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-[#C5A059]/15 blur-3xl"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-8">
      <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#EED8A1]">
        Your Sanctuary Awaits
      </p>
      <h2 className="mt-4 font-serif text-4xl font-semibold tracking-tight text-white sm:text-5xl">
        Ready to Relax?
      </h2>
      <p className="mt-4 text-sm text-stone-300 sm:text-base">
        Book your wellness experience at GK Wellness &amp; Luxury Spa.
      </p>
      <p
        data-testid="final-cta-offer"
        className="mt-6 inline-block rounded-full border border-[#C5A059]/40 bg-[#C5A059]/15 px-6 py-2.5 font-serif text-lg font-semibold tracking-wide text-[#EED8A1] sm:text-xl"
      >
        NEW SPA OPENING — FLAT 20% OFF
      </p>
      <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
        <WhatsAppButton
          message={WA_MESSAGES.general}
          label="Book on WhatsApp"
          testId="final-cta-whatsapp-btn"
          size="lg"
          className="w-full sm:w-auto"
        />
        <CallButton
          label="Call 8050533116"
          testId="final-cta-call-btn"
          size="lg"
          variant="onDark"
          className="w-full sm:w-auto"
        />
      </div>
    </div>
  </section>
);

export default FinalCta;
